import ApiService from './ApiService';

export default {
    all(){
        return ApiService.get('/links');
    },
    update(creds){
        return ApiService.put('/link/update', creds);
    }
}